import { apiNDISSupportItems } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

export const typePrefix = 'ndis/support-items';

const config = [{ actionType: 'getAll', apiPath: apiNDISSupportItems, method: get, actionParams: { limit: 0 } }];

export const { getAll } = createThunks(typePrefix, config);
